import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Details from '../views/Details.vue'
import Overview from '../views/Overview.vue'
import History from '../views/History.vue'
import Help from '../views/Help.vue'
import Admin from '../views/admin/Root.vue'
import Snapshots from '../views/admin/Snapshots.vue'
import Snapshot from '../views/admin/Snapshot.vue'
import Analytics from '../views/admin/Analytics.vue'
import RequestLogs from '../views/admin/RequestLogs.vue'
import Reports from '@/views/reports/Reports.vue'
import { trackVisitPage } from '@/core/services/tracking-service'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Overview',
    component: Overview
  },
  {
    path: '/details',
    name: 'Details',
    component: Details
  },
  {
    path: '/history',
    name: 'History',
    component: History
  },
  {
    path: '/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: Reports
  },
  {
    path: '/administration',
    name: 'administration',
    component: Admin,
    children: [
      {
        name: 'SnapshotList',
        path: 'snapshot',
        component: Snapshots
      },
      {
        name: 'Analytics',
        path: 'analytics',
        component: Analytics
      },
      {
        name: 'SnapshotDetails',
        path: 'snapshot/:id',
        component: Snapshot
      },
      {
        name: 'RequestLogs',
        path: 'request-logs',
        component: RequestLogs
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  trackVisitPage(to.name as string)
})

export default router
